import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {ActivityChartComponent} from "./activity-chart.component";
import {CalibrantLoadModule} from "../../shared/calibrant-load/calibrant-load.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CalibrantLoadModule,
    FontAwesomeModule
  ],
  declarations: [ActivityChartComponent],
  exports: [
    ActivityChartComponent
  ]
})
export class ActivityChartModule { }
